import { render } from "./BottomDrawer.vue?vue&type=template&id=784831f2&scoped=true"
import script from "./BottomDrawer.vue?vue&type=script&lang=js"
export * from "./BottomDrawer.vue?vue&type=script&lang=js"

import "./BottomDrawer.vue?vue&type=style&index=0&id=784831f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784831f2"]])

export default __exports__